<footer class="content-footer">
  <div class="footer">
    <div class="copyright">
      <span
        >Copyright © 2022 <b class="text-dark">Edifice Automotive</b>. All
        rights reserved.</span
      >
      <span class="go-right">
        <a
          href="https://www.edificeautomotive.com/privacy"
          class="text-gray mrg-right-15"
          >Term & Conditions</a
        >
        <a href="https://www.edificeautomotive.com/privacy" class="text-gray"
          >Privacy & Policy</a
        >
      </span>
    </div>
  </div>
</footer>
